import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "TheFooterBottomLinks footer-bottom-links" }
const _hoisted_2 = ["href"]

import { openModalDisclaimerDisclosure } from 'Components/ModalDisclaimerDisclosure';
import { handleOptOut } from '@/analytics';


export default /*@__PURE__*/_defineComponent({
  __name: 'TheFooterBottomLinks',
  setup(__props) {

function onOpenModalDisclaimerDisclosureClick() {
  openModalDisclaimerDisclosure();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      class: "link-4 small-link footer-bottom-links__link",
      onClick: _withModifiers(onOpenModalDisclaimerDisclosureClick, ["prevent"])
    }, " Disclosures "),
    _createElementVNode("a", {
      href: require('doc/AcreTrader.Electronic.Records.and.Signatures.Form.pdf'),
      target: "_blank",
      class: "link-4 small-link footer-bottom-links__link"
    }, " Consent for Electronic Delivery ", 8, _hoisted_2),
    _createElementVNode("button", {
      class: "link-4 small-link footer-bottom-links__link",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleOptOut) && _unref(handleOptOut)(...args)), ["prevent"]))
    }, " Opt Out of Online Tracking ")
  ]))
}
}

})